import { useSetFederationAdminMutation, useSetJudgeAdminMutation, useUpdateUserMutation } from '../mutations';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Schema } from '../create/components/user-form.schema';
import { UserForm } from '../create/components/user-form';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { idParamSchema } from '~/schemas';
import { useUserQuery } from '../queries';
import { toast } from 'react-toastify';

export function Page() {
  const params = useParams(idParamSchema.parse);
  const navigate = useNavigate()

  const federationAdminMutation = useSetFederationAdminMutation()
  const judgeAdminMutation = useSetJudgeAdminMutation()
  const mutation = useUpdateUserMutation();

  const { data } = useUserQuery(params.id);

  if (!data) {
    return false;
  }

  async function handleSubmit(payload: Schema) {
    await mutation.mutateAsync({
      id: params.id,
      payload: {
        first_name: payload.first_name,
        last_name: payload.first_name,
        username: payload.username,
        email: payload.email,
      },
    });

    await federationAdminMutation.mutateAsync({
      federation_admin: payload.permissions?.federation_admin ?? false,
      email: payload.email,
    })

    await judgeAdminMutation.mutateAsync({
      judge_admin: payload.permissions?.judge_admin ?? false,
      email: payload.email,
    })

    toast.success('Användaren har uppdaterats');
    navigate('/admin/users');
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Redigera användare" />
      <UserForm
        onSubmit={handleSubmit}
        defaultValues={{
          ...data,
          email: data.email ?? '',
        }}
        mode="edit"
      />
    </Fragment>
  );
}
